// Customers Groups Vuex

import state from './groupStates.js'
import * as getters from './groupGetters.js'
import * as mutations from './groupMutations.js'
import * as actions from './groupActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
